import React from 'react';
import { Space } from 'antd';
import coatIcon from './icons/coat_of_arms_of_Armenia.png';
import ktakIcon from './icons/ktak_logo.png';
import adbLogo from './icons/adb_logo.svg';
import tutorIcon from './icons/tutor_logo.svg';
import featureSolutionIcon from './icons/future_solutions.svg';
// import featureSolutionIcon from './icons/feature_solution.png';

import './Brands.less';

const TBrands = ({}) => {
  return (
    <div className="t-brands-container">
      <Space direction="horizontal" size="middle" className="t-brandImg">
        <img
          key={'coat_of_arms_of_Armenia'}
          className={'coatLogoStyle'}
          alt={'coat_of_arms_of_Armenia'}
          src={coatIcon}
          draggable={false}
        />
        <img
          key={'ktak_logo'}
          className={'ktakLogoStyle'}
          alt={'ktak_logo'}
          src={ktakIcon}
          draggable={false}
        />
        <img
          key={'adb_logo'}
          className={'adbLogoStyle'}
          alt={'adb_logo'}
          src={adbLogo}
          draggable={false}
        />
        <img
          key={'tutor_logo'}
          className={'tutorLogoStyle'}
          alt={'tutor_logo'}
          src={tutorIcon}
          draggable={false}
        />
        <img
          key={'feature_solution'}
          className={'featureSolutionLogoStyle'}
          alt={'feature_solution'}
          src={featureSolutionIcon}
          draggable={false}
        />
      </Space>
    </div>
  );
};

export default TBrands;
